import styled from "styled-components";

export const Container = styled.section`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;

export const Title = styled.h3`
  margin: 0 0 16px;
  padding: 0 16px;
  font-size: 18px;
  font-weight: 900;
  color: #000000;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  gap: 8px;
  padding-left: 16px;
  padding-right: 16px;
  scroll-behavior: smooth;
  overscroll-behavior-x: contain;
`;

/**
 * RN: card ~225px + 16 gap; PWA: ~85% of rail with visible peek.
 * `100%` = scroll row width (clamped by parent min-width:0).
 */
export const Card = styled.div`
  flex: 0 0 220px;
  width: 220px;
  border-radius: 16px;
  background: #fff;
  box-sizing: border-box;
  cursor: pointer;
  text-align: left;
  overflow: hidden;
`;

export const CardInner = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  box-sizing: border-box;
`;

export const Header = styled.div`
  font-size: 16px;
  font-weight: 900;
  color: #000000;
  line-height: 1.3;
  width: 156px;
`;

export const HeroImage = styled.img`
  width: 100%;
  height: 78px;
  border-radius: 9px;
  object-fit: cover;
`;

export const Features = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
`;

export const FeatureRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: 14px;
  line-height: 1.35;
  color: #000000;
`;

export const BulletIcon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 2px;
  object-fit: contain;
`;

export const DefaultBullet = styled.span`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 2px;
  border-radius: 50%;
  background: #22c55e;
`;

export const CTA = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: center;
  padding-top: 4px;
`;

export const CtaLabel = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 32px;
  border: 1px solid #008cff;
  border-radius: 8px;
  color: #008cff;
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
  box-sizing: border-box;
`;
